<template>
  <div>
    <div v-if="index === 0" class="tov__scale">
      <div v-for="(col, index) in cols" :key="`col-${index}`" class="unit">
        <p class="text-caption">{{ col }}</p>
      </div>
    </div>
    <div class="gradient" :style="{ background: createBackgroundString }">
      <div class="gradient__title">
        <div class="tov__title">
          <p class="text-body-1">{{ minLabel }}</p>
          <p class="text-body-1">{{ maxLabel }}</p>
        </div>
      </div>
      <div
        v-for="(result, index) in results"
        :key="`score-${index}`"
        class="unit"
      >
        <div class="circle" v-show="result > 0" :style="getDimensions(result)">
          <p>{{ result }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultsGradient",
  data() {
    return {
      unit: 0,
      results: {
        col1: 0,
        col2: 0,
        col3: 0,
        col4: 0,
        col5: 0,
        col6: 0,
        col7: 0,
      },
      cols: ["-3", "-2", "-1", "0", "1", "2", "3"],
    };
  },
  computed: {
    createBackgroundString() {
      const { results } = this;
      const col1 = this.returnColString(results.col1, 12, 1);
      const col2 = this.returnColString(results.col2, 25, 2);
      const col3 = this.returnColString(results.col3, 37, 3);
      const col4 = this.returnColString(results.col4, 50, 4);
      const col5 = this.returnColString(results.col5, 62.5, 5);
      const col6 = this.returnColString(results.col6, 75, 6);
      const col7 = this.returnColString(results.col7, 87.5, 7);
      return `linear-gradient(${90}deg, 
      hsla(0 ,0%,12%,1) 0%, 
      ${col1}, ${col2}, ${col3}, ${col4}, ${col5}, ${col6}, ${col7}, 
      hsla(0,0%,12%,0) 100%)`;
    },
  },
  components: {},
  props: {
    scores: {
      type: Object,
      default: () => {},
    },
    users: {
      type: Number,
      default: 0,
    },
    hue: {
      type: Number,
      default: 120,
    },
    index: {
      type: Number,
      default: 0,
    },
    saturation: {
      type: Number,
      default: 100,
    },
    maxScore: {
      type: Number,
      default: 15,
    },
    title: {
      type: String,
      default: "",
    },
    minLabel: {
      type: String,
      default: "",
    },
    maxLabel: {
      type: String,
      default: "",
    },
    overlay: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      Object.entries(this.scores).forEach((key, val) => {
        this.populateColor(key, val);
      });
    },
    returnColString(val, pos) {
      const bright = 60 / this.maxScore;
      // const sat = 90 / this.maxScore;
      const sat = this.overlay ? 100 : this.saturation;
      // hsla(120,100%,50%,0.3)
      if (val > 0) {
        return `hsla(${this.hue}, ${sat}%, ${Math.ceil(
          val * bright
        )}%, 1) ${pos}%`;
      } else {
        // return `hsla(0, 0%, 4%, 1) ${pos}%`;
        return this.overlay
          ? `hsla(${this.hue}, ${sat}%, 0%, 1) ${pos}%`
          : `hsla(${this.hue}, ${sat}%, 7%, 1) ${pos}%`;
      }
    },
    getDimensions(val) {
      const unit = 200 / this.maxScore;
      // const radius = this.clamp(20, 100, val * unit);
      const radius = this.clamp(val * unit, 45, 200);
      return { width: `${radius}px`, height: `${radius}px` };
    },
    clamp(number, min, max) {
      return Math.max(min, Math.min(number, max));
    },
    populateColor(key) {
      const { results } = this;
      switch (key[0]) {
        case "-3":
          results.col1 = key[1];
          break;
        case "-2":
          results.col2 = key[1];
          break;
        case "-1":
          results.col3 = key[1];
          break;
        case "0":
          results.col4 = key[1];
          break;
        case "1":
          results.col5 = key[1];
          break;
        case "2":
          results.col6 = key[1];
          break;
        case "3":
          results.col7 = key[1];
          break;
      }
    },
  },
};
</script>

<style lang="scss">
.tov__scale {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  .unit {
    width: 14%;
    flex-basis: 14%;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      padding: 0;
      margin: 0;
    }
  }
}
.tov__title {
  display: flex;
  justify-content: space-between;
  width: 100%;
  p {
    padding: 4px;
    margin: 0;
    line-height: 1;
  }
}
.gradient {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 100%;
  height: 250px;
  position: relative;
  margin-bottom: 2px;
  background: linear-gradient(
    90deg,
    hsla(0, 0, 12, 1) 0%,
    hsla(0, 0, 12, 1) 100%
  );
  .unit {
    width: 14%;
    flex: 1;
    flex-basis: 14%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  &__title {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
  }
}
.circle {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  border-radius: 50%;
  color: white;
  position: absolute;

  p {
    padding: 0;
    margin: 0;
    line-height: 1;
  }
}
</style>
